import type { MonthBand } from './scanScale';

/** Narrower than this and the label would spill across its neighbours. */
const MIN_LABEL_WIDTH = 34;

interface MonthBandsProps {
    bands: MonthBand[];
    height: number;
}

function MonthBands({ bands, height }: MonthBandsProps) {
    return (
        <div className="absolute inset-0 overflow-hidden rounded-lg" aria-hidden>
            {bands.map((band) => {
                const width = Math.max(0, band.endX - band.startX);
                return (
                    <div
                        key={band.key}
                        className={`absolute top-0 overflow-hidden ${band.shaded ? 'bg-gray-50' : 'bg-white'}`}
                        style={{ left: band.startX, width, height }}
                    >
                        {width >= MIN_LABEL_WIDTH && (
                            <span className="absolute top-1 left-1.5 whitespace-nowrap text-[9px] font-semibold uppercase leading-none tracking-wider text-gray-400">
                                {band.label}
                            </span>
                        )}
                    </div>
                );
            })}
        </div>
    );
}

export { MonthBands };
